import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Social.module.scss'

import { Container, Image, Button } from 'react-bootstrap'

const RutubeIcon = () => {
  return (
    <svg 
      width="17" 
      height="17" 
      viewBox="0 0 35 35" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask 
        id="mask0_1212_8146" 
        style={{ maskType: 'luminance' }} 
        maskUnits="userSpaceOnUse" 
        x="0" 
        y="0" 
        width="35" 
        height="35"
      >
        <path 
          d="M26.5152 0H8.48485C3.7988 0 0 3.7988 0 8.48485V26.5152C0 31.2012 3.7988 35 8.48485 35H26.5152C31.2012 35 35 31.2012 35 26.5152V8.48485C35 3.7988 31.2012 0 26.5152 0Z" 
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1212_8146)">
        <path d="M35 0H0V35H35V0Z" fill="#100943"/>
        <path 
          d="M35 17.5C44.665 17.5 52.5 9.66498 52.5 7.62939e-06C52.5 -9.66499 44.665 -17.5 35 -17.5C25.335 -17.5 17.5 -9.66499 17.5 7.62939e-06C17.5 9.66498 25.335 17.5 35 17.5Z" 
          fill="#ED143B"
        />
        <path 
          d="M21.6195 16.701H11.2793V12.6092H21.6195C22.2235 12.6092 22.6435 12.7145 22.8543 12.8983C23.065 13.0822 23.1956 13.4232 23.1956 13.9213V15.3905C23.1956 15.9153 23.065 16.2563 22.8543 16.4401C22.6435 16.624 22.2235 16.7026 21.6195 16.7026V16.701ZM22.3289 8.75156H6.89404V26.25H11.2793V20.557H19.3608L23.1956 26.25H28.1062L23.8782 20.5303C25.437 20.2993 26.1369 19.8217 26.7141 19.0344C27.2914 18.2472 27.5809 16.9885 27.5809 15.3088V13.9967C27.5809 13.0005 27.4754 12.2132 27.2914 11.6098C27.1073 11.0064 26.7929 10.4816 26.3461 10.0102C25.8742 9.56396 25.3489 9.24968 24.7181 9.03912C24.0874 8.85529 23.2994 8.75 22.3289 8.75V8.75156Z" 
          fill="white"
        />
      </g>
    </svg>
  );
};

class Social extends React.Component {

  render() {

    const { data, dark_bg, dark_bg_mob, vklink, youlink, rutubelink } = this.props

    return (
      <section className={styles.section}>
        {dark_bg != '' &&
          <>
            <Image className={styles.section_bg} src={dark_bg} width={1920} height={299} alt={`Фон`} />
            <Image className={styles.section_bg_mob} src={dark_bg_mob} width={375} height={482} alt={`Фон моб.`} />
          </>
        }
        <div className={styles.section_content}>
          <Container>
            <h2 className={styles.title} dangerouslySetInnerHTML={{__html: data?.title}} />
            <div className={styles.text} dangerouslySetInnerHTML={{__html: data?.text}} />
          </Container>
          <div className={styles.sep}></div>
          <Container>
            <div className={styles.buttons}>
              {vklink != `` &&
                <Button className={styles.btn} href={vklink} target='_blank' rel='nofollow' variant="light">
                  <div className={styles.icon}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5.93062 0.00187508L6.38625 0H8.61375L9.07 0.00187508L9.64125 0.00812534L9.91187 0.0125005L10.1731 0.0193758L10.425 0.0281262L10.6675 0.0381266L10.9012 0.0512521L11.1263 0.0668778L11.3419 0.0856286L11.55 0.106254C12.6375 0.22876 13.3831 0.49127 13.9456 1.05379C14.5081 1.61632 14.7706 2.36135 14.8931 3.44952L14.9144 3.65765L14.9325 3.87391L14.9481 4.09892L14.9606 4.33206L14.9762 4.69957L14.9838 4.95583L14.9919 5.35835L14.9975 5.93025L15 6.54277L14.9994 8.61348L14.9975 9.06975L14.9913 9.64103L14.9869 9.91166L14.98 10.1729L14.9713 10.4248L14.9613 10.6673L14.9481 10.9011L14.9325 11.1261L14.9137 11.3417L14.8931 11.5499C14.7706 12.6374 14.5081 13.3831 13.9456 13.9456C13.3831 14.5081 12.6381 14.7706 11.55 14.8931L11.3419 14.9144L11.1256 14.9325L10.9006 14.9481L10.6675 14.9606L10.3 14.9762L10.0437 14.9837L9.64125 14.9919L9.06938 14.9975L8.45687 15L6.38625 14.9994L5.93 14.9975L5.35875 14.9913L5.08812 14.9869L4.82688 14.98L4.575 14.9712L4.3325 14.9612L4.09875 14.9481L3.87375 14.9325L3.65813 14.9137L3.45 14.8931C2.3625 14.7706 1.61688 14.5081 1.05438 13.9456C0.491875 13.3831 0.229375 12.638 0.106875 11.5499L0.085625 11.3417L0.0675 11.1255L0.051875 10.9005L0.039375 10.6673L0.02375 10.2998L0.01625 10.0435L0.008125 9.64103L0.0025 9.06913L0 8.4566L0.000625 6.38589L0.0025 5.92962L0.00875 5.35835L0.013125 5.08771L0.02 4.82645L0.02875 4.57457L0.03875 4.33206L0.051875 4.0983L0.0675 3.87329L0.08625 3.65765L0.106875 3.44952C0.229375 2.36197 0.491875 1.61632 1.05438 1.05379C1.61688 0.49127 2.36188 0.22876 3.45 0.106254L3.65813 0.0850035L3.87437 0.0668778L4.09937 0.0512521L4.3325 0.0387516L4.7 0.023126L4.95625 0.0156257L5.35875 0.00750031L5.93062 0.00187508ZM4.24375 4.56207H2.53125C2.6125 8.46223 4.5625 10.8061 7.98125 10.8061H8.175V8.57473C9.43125 8.69974 10.3812 9.61853 10.7625 10.8061H12.5375C12.05 9.031 10.7688 8.04971 9.96875 7.6747C10.7688 7.21218 11.8937 6.08713 12.1625 4.56207H10.55C10.2 5.79962 9.1625 6.92466 8.175 7.03092V4.56207H6.5625V8.88725C5.5625 8.63723 4.3 7.42468 4.24375 4.56207Z" fill="#0084FF"/>
                    </svg>
                  </div>
                  <div className={styles.name}>Перейти</div>
                </Button>
              }
              {youlink != `` &&
                <Button className={styles.btn} href={youlink} target='_blank' rel='nofollow' variant="light">
                  <div className={styles.icon}>
                    <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.656 1.80064C16.4632 1.14092 15.8984 0.620758 15.1822 0.443141C13.8736 0.113281 8.63936 0.113281 8.63936 0.113281C8.63936 0.113281 3.4051 0.113281 2.09654 0.430454C1.39404 0.608071 0.81552 1.14092 0.622679 1.80064C0.27832 3.0059 0.27832 5.50522 0.27832 5.50522C0.27832 5.50522 0.27832 8.01722 0.622679 9.20979C0.81552 9.86951 1.38027 10.3897 2.09654 10.5673C3.41887 10.8972 8.63936 10.8972 8.63936 10.8972C8.63936 10.8972 13.8736 10.8972 15.1822 10.58C15.8984 10.4024 16.4632 9.8822 16.656 9.22248C17.0004 8.01722 17.0004 5.5179 17.0004 5.5179C17.0004 5.5179 17.0142 3.0059 16.656 1.80064Z" fill="#FF0000"/>
                      <path d="M6.97266 7.81335L11.3254 5.50433L6.97266 3.19531V7.81335Z" fill="white"/>
                    </svg>
                  </div>
                  <div className={styles.name}>Перейти</div>
                </Button>
              }
              {rutubelink != `` &&
                <Button className={styles.btn} href={rutubelink} target='_blank' rel='nofollow' variant="light">
                  <div className={styles.icon}>
                    <RutubeIcon />
                  </div>
                  <div className={styles.name}>Перейти</div>
                </Button>
              }
            </div>
            {data?.image != '' &&
              <div className={styles.section_image_container}>
                <Image className={styles.section_image} src={data?.image} alt={`${data?.title} - фото`} width={454} height={276} />
                <Image className={styles.section_image_mob} src={data?.image_mob} alt={`${data?.title} - фото`} width={375} height={282} />
              </div>
            }
          </Container>
        </div>
      </section>
    )
  }
}

Social.propTypes = {
  data: PropTypes.object,
  dark_bg: PropTypes.string,
  dark_bg_mob: PropTypes.string,
  vklink: PropTypes.string,
  youlink: PropTypes.string,
  rutubelink: PropTypes.string
}

Social.defaultProps = {
  data: {},
  dark_bg: '',
  dark_bg_mob: '',
  vklink: '',
  youlink: '',
  rutubelink: ''
}

export default Social